<template>
  <div class="page-section" :class="styleClass">
    <div class="container-cap">
      <header-img v-if="header" :src="header" />
      <h1 v-if="title" v-html="title"></h1>
      <h3 v-if="subtitle" v-html="subtitle"></h3>
      <hr v-if="title || subtitle">
      <slot name="default"></slot>
    </div>
  </div>
</template>
<script>
import headerImg from '@/components/headerimg'

export default {
  name: 'page-section',

  props: {
    type: {
      type: String,
      default: 'default'
    },

    header: {
      type: String
    },

    title: {
      type: String,
      default: ''
    },

    subtitle: {
      type: String,
      default: ''
    }
  },

  computed: {
    styleClass: function () {
      return `page-section-${this.type}`
    }
  },

  components: {
    headerImg
  }
}
</script>
<style scoped lang="less">
@import "~variables";

.page-section {
    h1 {
        margin-bottom: 3rem;
        margin-top: 3rem;
        text-align: center;
    }

    h3 {
      text-align: center;
    }

    h1:first-child {
        margin-top: 0rem;
    }

    padding-top: 4rem;
    padding-bottom: 4rem;

  @media (min-width: 0) and (max-width: @screen-sm-max) {
    padding-top: 0rem;
  }
}

.page-section-default {
  color: @base-text;
  .container-cap {
    h1 {
        color: @darker-base;
    }
  }
}

.page-section-dark-base {
  background-color: @dark-base;
  color: white;

  .container-cap {
    hr {
      border-color: white;
    }

    h1, h2, h3, h4, h5 {
      color: white;
    }
    .panel-body {
      color: @base-text;
    }
  }
}

</style>
